import { LinearProgress, Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
// import { useSelector } from 'react-redux'
// import { useLocation } from 'react-router-dom'
// import { AsyncState } from 'react-use/lib/useAsyncFn'
// import { Task } from 'redux-saga'
import chatApi from '../../api/chatApi'
import { Constructors_Task, getQuestion as apiGetQuestion, getTaskPoint, setQuestion, getUserID } from '../../api/chatApi/chatApi'
import { SidebarWidth } from '../../constants/default'
import useFinishTaskDialogState from '../../hooks/testingTask/useFinishTaskDialogState'
import { usePointProcentStore } from '../../pages/chat/store'
// import { RootState } from '../../store'
import { MenuItemData, Notes, ProgressBarType, User } from '../../types'
import { pxToRem, pxToRemGutter } from '../../utils'
// import CustomButton from '../common/CustomButton'
import ConfirmDialog from '../ConfirmDialog'
import MedNotes from '../MainSidebar/MedNotes'
import ProgressBar from '../MainSidebar/ProgressBar'
// import SidebarMenu from '../MainSidebar/SidebarMenu';
import UserInfo from '../MainSidebar/UserInfo'
import SidebarSteps from './SidebarSteps'
import DifferentialDiagnosisDialog from './DifferentialDiagnosisDialog'
import './index.css'

const useStyles = makeStyles(theme => ({
  sidebar: {
    width: pxToRem(SidebarWidth),
    height: '100vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    borderRight: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
    paddingTop: '15px',
    paddingBottom: '25px'
    // paddingBottom: 90,
  },
  progress_container: {
    width: '100%',
    padding: pxToRemGutter(0, 24, 16),
    margin: 0
  },
  blockWrap: {
    width: '100%',
    padding: pxToRemGutter(0, 24, 16),
    margin: 0,
    textAlign: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  blockModelBtn: {
    textAlign: 'center'
  }
}))
type Props = {
  user: User
  notes?: Notes
  anamnesisProgress: ProgressBarType
  anamnesisErrors: ProgressBarType
  mini: boolean
  menuItems: Array<MenuItemData>
  patientModel: any
}

interface TaskQuestionsData {
  questions: Array<{
    id: number;
    question: string;
    answer: string | null;
    success: boolean;
  }>;
  taskTheme: {
    name: string;
  };
}

declare global {
  interface Window {
    ym: any
  }
}

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress style={{ background: 'red', opacity: 0.7, height: 9 }} variant="determinate" value={props.value > 100 ? 100 : props.value} />
      </Box>
      <Box minWidth={35}>
        <Typography style={{ fontSize: 18 }} variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default function MainSidebar({
  user,
  notes,
  anamnesisProgress,
  anamnesisErrors,
  mini,
  patientModel
}: Props) {
  const classes = useStyles()
  const { close, onSubmit, open, show } = useFinishTaskDialogState()
  const [task, setTask] = useState(0);
  const [maxPointTask, setMaxPointTask] = useState(0);
  const [mainPont, setMainPoint] = useState(0);
  const [mainProcent, setMainProcent] = useState<number>(0);
  const [userId, setUserId] = useState(0);
  const [questionModalOpen, setQuestionModalOpen] = useState(false);
  const [questionText, setQuestionText] = useState('');
  const [taskQuestionsModalOpen, setTaskQuestionsModalOpen] = useState(false);
  const [taskQuestions, setTaskQuestions] = useState<TaskQuestionsData | null>(null);
  const [expertOnTask, setExpertOnTask] = useState(false);
  // const champ = localStorage.getItem('idChampForTask')
  const datas = usePointProcentStore(state => state.data)

  const champ = localStorage.getItem('idChamp')

  useEffect(() => {
    if (datas) {
      const point = datas.reduce(function (acc, obj) { return acc + obj.point; }, 0);
      const procent = datas.reduce(function (acc, obj) { return acc + obj.task_procent; }, 0);
      setMainPoint(point)
      setMainProcent(procent)
    }
  }, [datas]);


  const getTaskPoints = async (task) => {
    await getTaskPoint(task)
      .then(res => setMaxPointTask(res.data.task_point.max_point_task))
      .catch(err => console.log(err))
  }

  useEffect(() => {
    unfinishedTaskHandler()
    // window?.ym(87333080, 'hit', window.location.href);
  }, [])

  async function unfinishedTaskHandler() {
    try {
      const response = await chatApi.unfinishedTask()
      setExpertOnTask(response.result.task.expert)
      setTask(response.result.taskId)
      getTaskPoints(response.result.taskId)
    } catch (err) {
      console.log('при выполнении unfinishedTaskHandler', err);
    }
  }

  useEffect(() => {
    const getUserId = async () => {
      const response = await getUserID()
      setUserId(response.data.user_id)
    }
    getUserId()
  }, [])


  const view3dModel = useQuery('patientModel', async () => {
    const currTask: any = async () => await chatApi.unfinishedTask()
    const task = await currTask()

    return task?.result?.task?.patientModel?.view3dLink
  })



  const saveProcced = async () => {
    await chatApi.saveProcced(task, Number(champ), false)
      .then(res => console.log(res))
      .catch(err => console.log(err))
  }

  const completingTask = () => {
    if (champ) {
      saveProcced()
    }
    onSubmit()
  }

  const handleFinishTaskClick = () => {
    show()
  }


  const handleGetQuestionClick = async () => {
    try {
      const response = await apiGetQuestion({
        task_id: task,
        user_id: userId
      })

      if (response.data && response.data.data) {
        setTaskQuestions(response.data.data);
        setTaskQuestionsModalOpen(true);
      }
    } catch (err) {
      console.log('при выполнении getQuestion', err);
    }
  }

  const handleSetQuestionClick = () => {
    setQuestionModalOpen(true);
  }

  const handleCloseQuestionModal = () => {
    setQuestionModalOpen(false);
    setQuestionText('');
  }

  const handleSendQuestion = async () => {
    if (!questionText.trim()) return;

    try {
      const response = await setQuestion({ question: questionText })
      console.log(response.data)
      handleCloseQuestionModal();
    } catch (err) {
      console.log('при выполнении setQuestion', err);
    }
  }

  return (
    <div style={{ width: pxToRem(SidebarWidth), background: '#fff', borderRight: `1px solid gainsboro` }} className={classes.sidebar}>
      <UserInfo user={user} mini={mini} />
      <div className={classes.progress_container}>
        {/* <div style={{fontSize: 18}}>Максимальное количество баллов: {maxPointTask}</div>
        <div style={{fontSize: 18}}>Мои баллы: {mainPont}</div> */}
        <LinearProgressWithLabel value={mainProcent < 0 ? 0 : mainProcent} />
      </div>
      <div className={classes.blockWrap}>
        {/* show */}
        {champ
          ?
          <div>
            <Button onClick={handleFinishTaskClick} color='primary' variant='outlined'>
              Закончить задачу
            </Button>
            <div style={{ marginTop: 10, fontSize: 19 }}>Задача по чемпионату</div>
          </div>
          :
          <Button onClick={handleFinishTaskClick} color='primary' variant='outlined'>
            Закончить задачу
          </Button>
        }

        {expertOnTask ? <Box style={{ display: 'flex', flexDirection: 'column', gap: 10, border: '1px solid #1876D1', padding: 10, borderRadius: 4, marginTop: 15, fontSize: 12 }}>
          <Button onClick={handleGetQuestionClick} color='primary' variant='outlined' style={{ marginTop: 5, fontSize: 11 }}>
            Вопросы по задаче
          </Button>
          <Button onClick={handleSetQuestionClick} color='primary' variant='outlined' style={{ marginTop: 10, fontSize: 11 }}>
            Вопрос эксперту
          </Button>
        </Box> : null}


        {/* <Button onClick={show}>Закончить задачу</Button> */}
      </div>
      <div className={classes.blockModelBtn}>
      </div>
      <SidebarSteps />
      <DifferentialDiagnosisDialog />

      <ConfirmDialog
        open={open}
        title='Завершение задачи'
        content='Вы уверены, что хотите завершить задачу?'
        onClose={close}
        onSubmit={completingTask}
      />

      {/* Модальное окно для вопроса эксперту */}
      <Dialog
        open={questionModalOpen}
        onClose={handleCloseQuestionModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Задать вопрос эксперту</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Ваш вопрос"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={questionText}
            onChange={(e) => setQuestionText(e.target.value)}
            placeholder="Введите ваш вопрос эксперту..."
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseQuestionModal} color="primary">
            Отмена
          </Button>
          <Button onClick={handleSendQuestion} color="primary" variant="contained">
            Отправить
          </Button>
        </DialogActions>
      </Dialog>

      {/* Модальное окно с вопросами по задаче */}
      <Dialog
        open={taskQuestionsModalOpen}
        onClose={() => setTaskQuestionsModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Вопросы по задаче</DialogTitle>
        <DialogContent>
          {taskQuestions && taskQuestions.questions && (
            <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {taskQuestions.questions.map((question, index) => (
                <div key={index} style={{
                  marginBottom: 20,
                  padding: 16,
                  border: '1px solid #e0e0e0',
                  borderRadius: 8,
                  backgroundColor: '#f3f8ff'
                }}>
                  <div style={{
                    fontWeight: 'bold',
                    marginBottom: 8,
                    color: '#1976d2',
                    fontSize: '1.1rem'
                  }}>
                    Вопрос {index + 1}:
                  </div>
                  <div style={{ marginBottom: 12, fontSize: '1rem' }}>
                    {question.question}
                  </div>

                  {question.answer ? (
                    <div>
                      <div style={{
                        fontWeight: 'bold',
                        marginBottom: 8,
                        color: '#2e7d32',
                        fontSize: '1rem'
                      }}>
                        Ответ эксперта:
                      </div>
                      <div style={{ fontSize: '1rem' }}>
                        {question.answer}
                      </div>
                    </div>
                  ) : (
                    <div style={{
                      color: '#757575',
                      fontStyle: 'italic',
                      fontSize: '0.9rem'
                    }}>
                      Ответ эксперта еще не получен
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTaskQuestionsModalOpen(false)} color="primary" variant="contained">
            Закрыть
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
